import { render, staticRenderFns } from "./DemoSubmissionSuccess.vue?vue&type=template&id=79d14784&scoped=true"
import script from "./DemoSubmissionSuccess.vue?vue&type=script&lang=js"
export * from "./DemoSubmissionSuccess.vue?vue&type=script&lang=js"
import style0 from "./DemoSubmissionSuccess.vue?vue&type=style&index=0&id=79d14784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d14784",
  null
  
)

export default component.exports